import React from 'react';
import { FormGroup, Label, Input, Button, Row, Col } from 'reactstrap';

const KeyVisualsTab = ({ keyVisual = {}, updateLocalKeyVisualConfig }) => {
    const { breakpoints: keyVisualBreakpoints = [], altText: keyVisualAltText = undefined } = keyVisual;

    return (
        <div>
            {/* Section: Layout */}
            <div className="mb-4">
                <h2 className="h6 text-uppercase text-muted fw-bold border-bottom pb-2 mb-3">Layout</h2>
                <FormGroup switch className="mb-3">
                    <Input
                        type="switch"
                        id="isKeyVisualFullWidth"
                        checked={keyVisual.isFullWidth || false}
                        onChange={(e) => updateLocalKeyVisualConfig({ isFullWidth: e.target.checked })}
                    />
                    <Label check for="isKeyVisualFullWidth">
                        Volle Breite für Key-Visual
                    </Label>
                </FormGroup>
            </div>

            {/* Section: Key Visual Breakpoints */}
            <div className="mb-4">
                <h2 className="h6 text-uppercase text-muted fw-bold border-bottom pb-2 mb-3">Key-Visual-Breakpoints</h2>
                <div className="mb-3">
                    {(keyVisualBreakpoints || []).map((bp, idx) => (
                        <div key={idx} className="p-3 border rounded mb-3 bg-white">
                            <Row className="g-2 mb-2">
                                <Col xs="4">
                                    <Label className="small text-muted mb-1">Min. Breite (px)</Label>
                                    <Input
                                        type="number"
                                        value={bp.minWidth}
                                        onChange={(e) => {
                                            const newBps = [...(keyVisualBreakpoints || [])];
                                            newBps[idx] = {
                                                ...newBps[idx],
                                                minWidth: parseInt(e.target.value, 10) || 0,
                                            };
                                            updateLocalKeyVisualConfig({ breakpoints: newBps });
                                        }}
                                        placeholder="Min. Breite"
                                    />
                                </Col>
                                <Col xs="4">
                                    <Label className="small text-muted mb-1">Skalierung</Label>
                                    <Input
                                        type="number"
                                        value={bp.scale !== undefined && bp.scale !== null ? bp.scale : 1}
                                        min={0.1}
                                        max={2}
                                        step={0.05}
                                        onChange={(e) => {
                                            const newBps = [...(keyVisualBreakpoints || [])];
                                            newBps[idx] = {
                                                ...newBps[idx],
                                                scale: parseFloat(e.target.value) || 1,
                                            };
                                            updateLocalKeyVisualConfig({ breakpoints: newBps });
                                        }}
                                        placeholder="Skalierung"
                                    />
                                </Col>
                                <Col xs="4">
                                    <Label className="small text-muted mb-1">Max. Höhe (px)</Label>
                                    <Input
                                        type="number"
                                        value={bp.maxHeight !== undefined && bp.maxHeight !== null ? bp.maxHeight : ''}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            const newBps = [...(keyVisualBreakpoints || [])];
                                            newBps[idx] = {
                                                ...newBps[idx],
                                                maxHeight: val === '' ? undefined : parseInt(val, 10) || undefined,
                                            };
                                            updateLocalKeyVisualConfig({ breakpoints: newBps });
                                        }}
                                        placeholder="Automatisch"
                                    />
                                </Col>
                            </Row>
                            <Row className="g-2 mb-2">
                                <Col xs="6">
                                    <Label className="small text-muted mb-1">Fokuspunkt X (%)</Label>
                                    <Input
                                        type="number"
                                        value={
                                            bp.focalPoint && bp.focalPoint.x !== undefined && bp.focalPoint.x !== null
                                                ? bp.focalPoint.x
                                                : 50
                                        }
                                        min={0}
                                        max={100}
                                        onChange={(e) => {
                                            const newBps = [...(keyVisualBreakpoints || [])];
                                            newBps[idx] = {
                                                ...newBps[idx],
                                                focalPoint: {
                                                    ...(newBps[idx].focalPoint || { x: 50, y: 50 }),
                                                    x: parseInt(e.target.value, 10) || 0,
                                                },
                                            };
                                            updateLocalKeyVisualConfig({ breakpoints: newBps });
                                        }}
                                        placeholder="Fokuspunkt X"
                                    />
                                </Col>
                                <Col xs="6">
                                    <Label className="small text-muted mb-1">Fokuspunkt Y (%)</Label>
                                    <Input
                                        type="number"
                                        value={
                                            bp.focalPoint && bp.focalPoint.y !== undefined && bp.focalPoint.y !== null
                                                ? bp.focalPoint.y
                                                : 50
                                        }
                                        min={0}
                                        max={100}
                                        onChange={(e) => {
                                            const newBps = [...(keyVisualBreakpoints || [])];
                                            newBps[idx] = {
                                                ...newBps[idx],
                                                focalPoint: {
                                                    ...(newBps[idx].focalPoint || { x: 50, y: 50 }),
                                                    y: parseInt(e.target.value, 10) || 0,
                                                },
                                            };
                                            updateLocalKeyVisualConfig({ breakpoints: newBps });
                                        }}
                                        placeholder="Fokuspunkt Y"
                                    />
                                </Col>
                            </Row>
                            <Row className="g-2 align-items-end">
                                <Col>
                                    <Label className="small text-muted mb-1">Bild-URL</Label>
                                    <Input
                                        type="text"
                                        value={bp.url}
                                        onChange={(e) => {
                                            const newBps = [...(keyVisualBreakpoints || [])];
                                            newBps[idx] = { ...newBps[idx], url: e.target.value };
                                            updateLocalKeyVisualConfig({ breakpoints: newBps });
                                        }}
                                        placeholder="Bild-URL"
                                    />
                                </Col>
                                <Col xs="auto">
                                    <Button
                                        color="danger"
                                        onClick={() => {
                                            const newBps = (keyVisualBreakpoints || []).filter((_, i) => i !== idx);
                                            updateLocalKeyVisualConfig({ breakpoints: newBps });
                                        }}
                                    >
                                        Löschen
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    ))}
                    <Button
                        color="primary"
                        outline
                        className="w-100"
                        onClick={() => {
                            const newBps = [
                                ...(keyVisualBreakpoints || []),
                                { minWidth: 768, url: '', scale: 1, focalPoint: { x: 50, y: 50 } },
                            ];
                            updateLocalKeyVisualConfig({ breakpoints: newBps });
                        }}
                    >
                        Breakpoint hinzufügen
                    </Button>
                </div>

                <FormGroup switch className="mb-2 mt-2">
                    <Input
                        type="switch"
                        id="keyVisualAltTextSwitch"
                        checked={keyVisualAltText === undefined || keyVisualAltText === ''}
                        onChange={(e) => {
                            if (e.target.checked) {
                                updateLocalKeyVisualConfig({ altText: '' });
                            } else {
                                updateLocalKeyVisualConfig({ altText: 'Key-Visual' });
                            }
                        }}
                    />
                    <Label check for="keyVisualAltTextSwitch">
                        Als dekorativ markieren (leerer Alt-Text)
                    </Label>
                </FormGroup>

                {keyVisualAltText !== undefined && keyVisualAltText !== '' && (
                    <FormGroup className="mb-3">
                        <Label for="keyVisualAltText">Key-Visual-Alt-Text</Label>
                        <Input
                            type="text"
                            id="keyVisualAltText"
                            value={keyVisualAltText}
                            onChange={(e) => {
                                const val = e.target.value;
                                updateLocalKeyVisualConfig({ altText: val === '' ? undefined : val });
                            }}
                            placeholder="z.B. Kampagnen Key-Visual"
                        />
                    </FormGroup>
                )}
            </div>
        </div>
    );
};

export default KeyVisualsTab;
